import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

// Using TomSelect for multi-select dropdowns
// Docs: https://tom-select.js.org/docs/

export default class extends Controller {
    static values = {
        allowEmptyOption: Boolean,
        plugins: Array,
        create: Boolean,
        maxOptions: Number,
        blurOnSelect: Boolean,
    }

    connect() {
        const settings = {
            allowEmptyOption: this.allowEmptyOptionValue,
            plugins: this.pluginsValue,
            create: this.createValue,
            createOnBlur: true,
            maxOptions: this.maxOptionsValue || 50,
            // Remove focus after selection
            onItemAdd: () => {
                if (this.blurOnSelectValue) {
                    this.tomSelect.blur()
                }
            }
        }

        this.tomSelect = new TomSelect(this.element, settings)
    }

    disconnect() {
        this.tomSelect?.destroy()
    }
}
